// extracted by mini-css-extract-plugin
export var fileUpload = "_hi-1";
export var modalButton = "_hi-0";